import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import React from 'react';

type Props = {
  checked: boolean;
  handleDevLangChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const DevLongLanguageToggle = (props: Props) => {
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Switch checked={props.checked} onChange={props.handleDevLangChange} color="primary" />
        }
        label="Long Language"
      />
    </FormGroup>
  );
};

export default DevLongLanguageToggle;
